import { getDataIdsFromContract } from '../../shared/utils/dataId';

export const confirmDialogDataIds = getDataIdsFromContract({
  base: 'confirm-dialog',
  icon: 'icon',
  title: 'title',
  body: 'body',
  close: 'close',
  cancel: 'cancel',
  errorBanner: 'error-banner',
  confirm: 'confirm',
  confirmationSubText: 'confirm-sub-text',
  confirmationInput: 'confirmation-input'
});
